import { render, staticRenderFns } from "./ThemeSwitch.vue?vue&type=template&id=7a82823c&"
import script from "./ThemeSwitch.vue?vue&type=script&lang=js&"
export * from "./ThemeSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ThemeSwitch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports